import EyeDropperIcon from "$/lib/icons/EyeDropperIcon";
import type { EyeDropPickerProps } from "./ColorPicker.types";

export const EyeDropPicker = ({
  pickColor,
  isSupported,
}: EyeDropPickerProps) => {
  if (!isSupported) return <></>;

  return (
    <button className="text-black" onClick={pickColor}>
      <EyeDropperIcon />
    </button>
  );
};
